const shadows = {
  xs: "0 0 14px 0 #00000014",
  sm: "0 0 8px 0 #0000000a",
  md: "0 1px 2px 0 #00000014",
  lg: "0 1px 1px 0 #0000000f",
  xl: "0 0 16px 0 #00000019",
  "2xl": "0 1px 2px 0 #1018280a",
};
export default shadows;
